import {
  APP_LOCALE_LABELS,
  APP_LOCALES,
  getLocale,
} from "@airange/shared/i18n-airange-admin-runtime";
import { GlobalOutlined } from "@ant-design/icons";
import { useIntl } from "@umijs/max";
import { Select, Space, Typography } from "antd";
import { useState } from "react";
import { platformAdminLocaleController } from "../lib/locale";

export function LocaleSwitch() {
  const intl = useIntl();
  const [locale, setLocale] = useState(() => getLocale());

  return (
    <Space size={8}>
      <GlobalOutlined />
      <Typography.Text>{intl.formatMessage({ id: "platform.common.locale" })}</Typography.Text>
      <Select
        size="small"
        value={locale}
        options={APP_LOCALES.map((value) => ({ value, label: APP_LOCALE_LABELS[value] }))}
        style={{ width: 124 }}
        onChange={(value: string) => {
          setLocale(platformAdminLocaleController.switchLocale(value));
        }}
      />
    </Space>
  );
}
